const KeepaliveConfig = function (IdleProvider, KeepaliveProvider) {
    const keepAliveTimerMinutes = 2 * 60; //2 minutes
    const idleTimerMinutes = 4 * 60; //4 minutes
    const keepaliveEndpoint = __baseApiUrl__ + "/participant-web-services/rest/nonauth/keepAlive";

    IdleProvider.idle(idleTimerMinutes);
    IdleProvider.timeout(idleTimerMinutes);
    IdleProvider.keepalive(false);

    KeepaliveProvider.interval(keepAliveTimerMinutes);
    KeepaliveProvider.http(keepaliveEndpoint);
};

KeepaliveConfig.$inject = ["IdleProvider", "KeepaliveProvider"];
export default KeepaliveConfig;
